import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import moment from 'moment';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button } from 'react-bootstrap'
import { Selector } from '@leverege/ui-elements';
import { NotifyActions } from '~/actions'
import { TextInput, LabelGroup, Section, Text, Flex } from '~/views';

import style from './style.css'

class RestNetworkEditor extends React.Component {

  static propTypes = {
    network : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.state = { showDialog : false }
  }

  changePath( path, value, err ) {
    if ( err ) {
      console.log( `error setting ${key} to ${value}` );
      return;
    }
    this.props.onChange( { target : this.props.network, path, value } );
  }

  copySecret = () => {
    const { dispatch } = this.props
    dispatch( NotifyActions.success( 'Copy', 'The Secret has been copied to your clipboard' ) )
  }

  copyApiKey = () => {
    const { dispatch } = this.props
    dispatch( NotifyActions.success( 'Copy', 'The Api Key has been copied to your clipboard' ) )
  }

  render() {
    const { network } = this.props
    if ( network == null ) {
      return <div />
    }

    const alias = null
    return (
      <Section title={network.name}>
        <Flex variant="vSpace" align="stretch" direction="column">
          <LabelGroup>
            <label>ID</label>
            <Text type="dim" text={network.id} />
          </LabelGroup> 
          <LabelGroup>
            <label>Name</label>
            <TextInput hint="Name..."
              value={network.name} 
              changeOnReturn 
              onChange={( v, err ) => { this.changePath( 'name', v, err ) }} />
          </LabelGroup>
          <LabelGroup>
            <label>URL</label>
            <TextInput hint="URL..."
              value={network.url}
              changeOnReturn 
              onChange={( v, err ) => { this.changePath( 'url', v, err ) }} />
          </LabelGroup>
          <LabelGroup>
            <label />
            <Text type="dim">{'Use ${deviceId} to insert device id into url'}</Text>
          </LabelGroup>
          <LabelGroup>
            <label>Method</label>
            <Selector
              values={[ { value : 'POST', name : 'POST' }, { value : 'PUT', name : 'PUT' } ]}
              value={network.method}
              onChange={( value ) => { this.changePath( 'method', value.value, false ); }} />

          </LabelGroup>

          <LabelGroup className={style.apiKeyItem}>
            <label>Api Key</label>
            <TextInput className={style.apiKey} value={network.id} disabled="true" />
            <CopyToClipboard text={network.id} onCopy={this.copyApiKey}>
              <Button bsSize="small" bsStyle="link" title="Copy to Clipboard"> 
                {' '}
                <i className="fa fa-copy fa-fw" />
              </Button>
            </CopyToClipboard>
          </LabelGroup>
          <LabelGroup className={style.secretItem}>
            <label>Secret</label>
            <TextInput className={style.secret} value={network.secret} disabled="true" />
            <CopyToClipboard text={network.secret} onCopy={this.copySecret}>
              <Button bsSize="small" bsStyle="link" title="Copy to Clipboard"> 
                {' '}
                <i className="fa fa-copy fa-fw" />
              </Button>
            </CopyToClipboard>
          </LabelGroup>
          <LabelGroup className={style.apiKeyItem}>
            <label />
            <div className={style.identifier}>{`Created ${moment( network.created ).format( 'lll' )}` }</div>
          </LabelGroup>
        </Flex>
      </Section>
    ) 
  }
}

function keyValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /[a-zA-Z0-9_\-:]/.test( inp ) ) {
    return true;
  }
  return false;
}

export default connect( state => ( { } ) )( RestNetworkEditor )
